module.exports = __webpack_public_path__ + "img/6.d276b844.png";